import { Expo, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const zoomOut: gsapTimelineFunc = (targets) => {
  return gsap.timeline().fromTo(
    targets,
    {
      duration: 0,
      opacity: 0,
      scale: 2,
      ease: Expo.easeOut,
      transformOrigin: 'center center',
    },
    {
      duration: 1,
      opacity: 1,
      scale: 1,
      ease: Expo.easeOut,
    }
  );
};
